<template>
    <div id="testimonials">
        <div class="testimonials_section">
            <div class="testimonial" v-for="(item, i) in renderTestimonials" :key="i">
                <p class="testimonial__message">{{ displayMessage(item) }}</p>
                <p class="testimonial__name">- {{ item.full_name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    const data = {
        testimonials: {
            items: []
        }
    };
    const apiToken = require('../../../credentials').API_TOKEN;
    const urlPath = require('../../../credentials').URL_PATH;

    import axios from 'axios'

    export default {
        name: 'Testimonials',
        data() {
            return data;
        },
        computed: {

            renderTestimonials() {
                if (this.testimonials !== undefined && this.testimonials !== 'undefined') {
                    return this.testimonials.items;
                }
            }
        },
        methods: {
            hydrateTestimonials() {
                axios.get(urlPath + 'testimonials/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then(res => {
                        this.testimonials.items = res.data;
                    })
            },
            displayMessage(item) {
                if (item.message !== undefined && item.message !== 'undefined') {
                    return item.message;
                }
            }
        },
        created() {
            this.hydrateTestimonials();
        }
    }
</script>

<style lang="scss" scoped>
    #testimonials {
        width: 100%;
        max-width: 1100px;
        margin: 30px auto 25px auto;
        padding: 20px 30px;
        .testimonials_section {
            margin: 50px auto;
            .testimonial {
                margin-bottom: 50px;
                .testimonial__message {
                    font-size: 20px;
                    white-space: pre-wrap;
                }
                .testimonial__name {
                    margin: 0 auto;
                    text-align: center;
                    font-size: 20px;
                    font-weight: bolder;
                }
            }
            /*.testimonial:first-child {*/
                /*<!--margin: -50px -100px -150px -100px;-->*/
            /*}*/
            /*.testimonial:not(:first-child) {*/
                /*<!--margin: -150px -100px;-->*/
            /*}*/
            /*.testimonial:last-child {*/
                /*<!--margin: -150px -100px 0 -100px;-->*/
            /*}*/
        }
    }

    @media screen and (max-width: 450px) {
        #testimonials {
            width: 100%;
            padding: 0 15px;
            max-width: 400px;

            .testimonials_section {
                .testimonial {
                    border: solid 1px black;
                    border-radius: .5em;
                    padding: 15px;
                    .testimonial__message {
                        font-size: 16px;
                    }
                    .testimonial__name {
                        font-size: 16px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        #testimonials {
            max-width: 900px;
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/about/Testimonials.vue